import { GraphQLExecutor } from '@app/model/_common/service/GraphQLExecutor';
import MarketStateFilterInput from '@app/model/market_state/input/MarketStateFilterInput';
import { PromotionOverview } from '@app/model/promotion/PromotionOverview';
import { FIND_PROMOTION_OVERVIEW_QUERY } from '@app/model/promotion/service/PromotionOverviewGraphQLQueries';

export default class PromotionOverviewService {
	public static find(variables: {
		companyHotelId: number;
		filterInput: MarketStateFilterInput;
		includeBookingFunded: boolean;
	}) {
		return GraphQLExecutor.execute<PromotionOverview>(FIND_PROMOTION_OVERVIEW_QUERY, variables);
	}
}
